import { useCallback } from 'react'
import { useT } from '_metronic/i18n/Metronici18n'
import { TipoDocumento } from '../../core/montagem/documentos'
import { Selo } from '../../core/montagem/itens'
import { CampoPendente } from '../../core/montagem/pendencias'

/** Textos derivados do domínio (título de documento, nome de selo e de campo), num lugar só. */
export const useRotulos = () => {
  const { t } = useT()

  const tituloDocumento = useCallback(
    ({ tipo, complemento }: { tipo: TipoDocumento; complemento?: string }) => {
      const titulo = t(`prescricao.documento.${tipo}`)
      return complemento ? `${titulo} · ${complemento}` : titulo
    },
    [t]
  )

  const rotuloSelo = useCallback((selo: Selo) => t(`prescricao.selo.${selo}`), [t])

  const rotuloCampo = useCallback((campo: CampoPendente) => t(`prescricao.pendencia.${campo}`), [t])

  return { t, tituloDocumento, rotuloSelo, rotuloCampo }
}
